import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';
import OptimizedImage from 'components/shared/OptimizedImage';

class SMSlidePhotoView extends React.Component {

  constructor(props) {
    super(props);
    
    const images = this.props.room.thumbnails.map((t, i) => {
      if (i === 0 || i === 1 || i === this.props.room.thumbnails.length - 1) {
        return this.getImageUrl(i, false);
      } else {
        return null;
      }
    });

    this.state = {
      images: images,
      thumbnails: this.props.room.thumbnails.map(t => null),
    };
  }

  componentDidMount() {
    const $modal = $(this.refs.modal);
    $modal.on("click", (e)=>{
      $modal.find(".md-close").click();
    });  
    $modal.find(".md-content").on("click", (e)=>{
      e.stopPropagation();
    });  
  }
  
  dismiss(e) {
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.slidePhotoDidClose === 'function'){
        this.props.delegate.slidePhotoDidClose();
      }
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen === true && prevProps.isOpen === false) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({afterClose: (modal, e)=>{
        this.dismiss();
        SMAppHelper.canBodyScroll(true);
        e.preventDefault();
      }});
      this.$carousel = $(this.refs.carousel).flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 75,
        itemHeight: 50,
        itemMargin: 10,
        touch: false,
        asNavFor: '#slider',
      });
      this.$slider = $(this.refs.slider).flexslider({
        animation: "fade",
        //animation: "slide",
        animationSpeed: 300,
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        touch: true,
        sync: "#carousel",
        start: (slider)=> {
          const fetchIndexes = this.getFetchIndexes(slider);
          const images = this.state.images.map((image, i) => {
            return (this.state.images[i] === null && fetchIndexes.indexOf(i) !== -1) ? this.getImageUrl(i, false) : image;
          });
          const thumbnails = SMAppHelper.isMobile() ? this.state.thumbnails
                                                    : this.props.room.thumbnails.map((t, i)=> this.getImageUrl(i, true));
          this.setState({
            images: images,
            thumbnails: thumbnails, 
          });
        },
        before: (slider)=> {
          const fetchIndexes = this.getFetchIndexes(slider);
          const images = this.state.images.map((image, i) => {
            return (this.state.images[i] === null && fetchIndexes.indexOf(i) !== -1) ? this.getImageUrl(i, false) : image;
          });
          
          this.setState({
            images: images,
          });
        },
      });
      this.$slider.flexslider(this.props.selectedPhotoIndex);
    }
  }
  
  getImageUrl(index, isThumbnail) {
    if (isThumbnail) {
      return SMFormatHelper.imageURLWithTransform(
        this.props.room.thumbnails[index].image, {width: 219, height: 144});
    } else {
      if (SMAppHelper.isMobile()) {
        return this.props.room.thumbnails[index].image;
      } else {
        return SMFormatHelper.imageURLWithTransform(
          this.props.room.thumbnails[index].image, {width: 1200, height: 670});
      }
    }
  }
  
  getFetchIndexes(slider) {
    let fetchIndexes = [];
    fetchIndexes.push(slider.animatingTo);
    
    if (slider.animatingTo === 0) {
      fetchIndexes.push(slider.last);
    } else if (slider.animatingTo > 0) {
      fetchIndexes.push(slider.animatingTo - 1);
    }
    
    if (slider.animatingTo === slider.last) {
      fetchIndexes.push(0);
    } else if (slider.animatingTo < slider.last) {
      fetchIndexes.push(slider.animatingTo + 1);
    }
    
    return Array.from(new Set(fetchIndexes));
  }
  
  render() {

    const room = this.props.room;
    let slides = [];
    let thumbnails = [];
    this.props.room.thumbnails.forEach((thumbnail, i)=>{
      
      slides.push(
        <li key={"slide" + i}>
          <OptimizedImage src={this.state.images[i]} alt={sprintf("%s の写真", SMFormatHelper.roomName(room))} />
          <div className="flex-caption"><p>{thumbnail.description}</p></div>
        </li>
      );
      thumbnails.push(
        <li key={"carousel" + i}>
          <OptimizedImage src={this.state.thumbnails[i]} alt={sprintf("%s のサムネイル", SMFormatHelper.roomName(room))}  className="" />
        </li>
      );
    });

    return (
      <div>
        <div className="md-modal-cover md-effect-101" ref="modal">
          <div className="md-content">
            <p className="slider-gallery__cancel"><a href="#" onClick={this.dismiss} className="md-close">×</a></p>
            <div className="slider-gallery-inner">
              <div id="slider" ref="slider" className="flexslider">
                <ul className="slides">
                  {slides}
                </ul>
              </div>
              <div id="carousel" ref="carousel" className="flexslider">
                <ul className="slides">
                  {thumbnails}
                </ul>
              </div>
            </div>
      		</div>
        </div>
        <div className="md-overlay"></div>
      </div>
    );
  }

}
export default SMSlidePhotoView;



// WEBPACK FOOTER //
// ./app/javascript/components/rooms/SMSlidePhotoView.jsx